import {Action, createReducer} from '@ngrx/store';
import {produceOn} from "../../common";
import {initialConfigState} from "../state/config.state";
import {IUIConfigState} from "../../interfaces";
import {
    actionAccountPollLiveChatReply,
    actionAccountPollLiveChatV2Reply,
    actionAccountSocialLoginReply,
    actionAccountSocialLoginRequest,
    actionAppSettings,
    actionDuplicateScene,
    actionDuplicateSceneCommand,
    actionIndexHTMLStatics,
    actionLoadOS,
    actionLogger,
    actionLoginViewMode,
    actionPostChatSessionId,
    actionSceneFontsPreviewed,
    actionSceneItemLocation,
    actionSceneItemLocationCoords,
    actionSceneItemPlaylist,
    actionSceneSvgColor,
    actionSelectedSceneId,
    actionSelectedSceneItemId,
    actionSelectedSchedule,
    localStorageUpdates,
    actionCopySceneAnimation,
    actionSelectedSceneTouchId,
    actionSetEditorMode,
    actionSceneBreadcrumbsSet,
    actionSceneBreadcrumbsPush,
    actionSceneBreadcrumbsClear,
    actionSceneJumpLinked,
} from "../actions/user.actions";
import {actionFasterqConfig} from "../actions/fasterq.actions";
import * as _ from 'lodash';

// const configReducer = produce<State, createAction>()

const featureReducer = createReducer(
    initialConfigState,
    produceOn(actionLogger, (draft, action) => {
        draft.logger.push(action.log);
    }),
    produceOn(actionLoginViewMode, (draft, action) => {
        draft.appSettings.loginState = action.loginViewMode;
    }),
    produceOn(actionSelectedSceneId, (draft, action) => {
        draft.uiSceneConfig.selectedSceneId = action.id;
    }),
    produceOn(actionSelectedSceneItemId, (draft, action) => {
        draft.uiSceneConfig.selectedSceneItemId = action.id;
    }),
    produceOn(actionAppSettings, (draft, action) => {
        draft.appSettings = action.appData;
    }),
    produceOn(actionLoadOS, (draft, action) => {
        draft.os = action.os;
    }),
    produceOn(actionSceneItemLocation, (draft, action) => {
        draft.uiSceneConfig.sceneItemLocationIndexes = action.indexes;
    }),
    produceOn(actionSceneSvgColor, (draft, action) => {
        draft.uiSceneConfig.sceneItemSvgColor = action.payload;
    }),
    produceOn(actionSceneFontsPreviewed, (draft, action) => {
        draft.uiSceneConfig.fontsPreviewed = action.fonts;
    }),
    produceOn(actionSceneItemLocationCoords, (draft, action) => {
        draft.uiSceneConfig.sceneItemLocationCoords = action.indexes;
    }),
    produceOn(actionSceneItemPlaylist, (draft, action) => {
        if (!draft.uiSceneConfig.sceneItemPlaylistIndexes) {
            draft.uiSceneConfig.sceneItemPlaylistIndexes = action.indexes;
            return;
        }
        if (draft.uiSceneConfig.sceneItemPlaylistIndexes[0] !== action.indexes[0])
            draft.uiSceneConfig.sceneItemPlaylistIndexes = action.indexes;
    }),
    produceOn(actionAccountSocialLoginRequest, (draft, action) => {
        draft.socialUser = action.payload;
    }),
    produceOn(actionAccountSocialLoginReply, (draft, action) => {
        draft.socialUserServerReply = action.payload;
    }),
    produceOn(actionDuplicateScene, (draft, action) => {
        draft.uiSceneConfig.lastDuplication = action.items;
    }),
    produceOn(actionDuplicateSceneCommand, (draft, action) => {
        draft.uiSceneConfig.lastDuplicationCommand = action.command;
    }),
    produceOn(actionCopySceneAnimation, (draft, action) => {
        draft.uiSceneConfig.sceneAnimationClipboard = action.animation;
    }),
    produceOn(actionFasterqConfig, (draft, action) => {
        _.merge(draft.fasterq, action);
    }),
    produceOn(localStorageUpdates, (draft, action) => {
        draft.localStorageUpdates = action.localStorageUpdates;
    }),
    produceOn(actionAccountPollLiveChatReply, (draft, action) => {
        draft.chat.liveStatus = action.liveChatStatus;
    }),
    produceOn(actionAccountPollLiveChatV2Reply, (draft, action) => {
        draft.chat.liveStatusV2 = action.chatServerReply.support;
    }),
    produceOn(actionPostChatSessionId, (draft, action) => {
        draft.chat.sessionId = action.sessionId;
    }),
    produceOn(actionIndexHTMLStatics, (draft, action) => {
        draft.staticIndexHTML = action.staticIndexHTML;
    }),
    produceOn(actionSelectedSchedule, (draft, action) => {
        draft.scheduleSelectionState.scheduler = action.scheduleSelection.scheduler;
    }),
    produceOn(actionSelectedSceneTouchId, (draft, action) => {
        draft.touchConfig = action.selectedTouch;
    }),
    produceOn(actionSetEditorMode, (draft, action) => {
        draft.editorMode = action.editorMode;
    }),
    produceOn(actionSceneBreadcrumbsSet, (draft, action) => {
        draft.uiSceneConfig.breadcrumbs = action.breadcrumbs || [];
    }),
    produceOn(actionSceneBreadcrumbsPush, (draft, action) => {
        if (!draft.uiSceneConfig.breadcrumbs) {
            draft.uiSceneConfig.breadcrumbs = [];
        }
        // Prevent duplicate consecutive breadcrumbs. Key on sceneId AND sceneItemId so an in-scene component
        // crumb (same sceneId as its parent scene, distinct sceneItemId) is not collapsed into the scene crumb.
        const lastBreadcrumb = draft.uiSceneConfig.breadcrumbs[draft.uiSceneConfig.breadcrumbs.length - 1];
        const isDuplicate = lastBreadcrumb
            && lastBreadcrumb.sceneId === action.breadcrumb.sceneId
            && lastBreadcrumb.sceneItemId === action.breadcrumb.sceneItemId;
        if (!isDuplicate) {
            draft.uiSceneConfig.breadcrumbs.push(action.breadcrumb);
        }
    }),
    produceOn(actionSceneBreadcrumbsClear, (draft) => {
        draft.uiSceneConfig.breadcrumbs = [];
    }),
    produceOn(actionSceneJumpLinked, (draft, action) => {
        draft.uiSceneConfig.previousLinkedSceneId = action.previousLinkedSceneId;
        draft.uiSceneConfig.previousSlidesSceneId = action.previousSlidesSceneId;
    })
    // ,
    // produceOn(actionResellerLogo, (draft, action) => {
    //     draft.resellerLogo = action.resellerLogo;
    // })
);

export function configReducers(state: IUIConfigState | undefined, action: Action): IUIConfigState {
    return featureReducer(state, action);
}
